
const stickyElm = document.querySelector('.sticky__add__to__cart');
if(stickyElm) {
  let isVisible = false;

  const observer = new IntersectionObserver(
    ([e]) => {
      isVisible = e.isIntersecting;
      stickyElm.classList.toggle('isSticky', isVisible);
    },
    {
      root: null,
      rootMargin: '-400px 0px', // Margines 400px od górnej i dolnej krawędzi okna
      threshold: 0
    }
  );
  
  observer.observe(stickyElm);
  
}
